<div class="flex-column height-100 bg-col-w"
     [style]="client.isS || client.isM ? 'border-top-left-radius: 20px; border-top-right-radius: 20px;' : ''">
    <div class="p-a-5 b-b b-col-5 p-a-4-s p-a-4-m">
        <div class="flex flex-justify-between flex-middle">
            <p class="h3"
               *iCms="'title' of content"></p>
            <button role="button"
                    class="flex"
                    aria-label="Close"
                    (click)="close()">
                <i class="icon-close"
                   aria-hidden="true"></i>
            </button>
        </div>
    </div>

    <!-- content -->
    <div class="overflow-auto custom-scrollbar flex-grow p-l-5 p-r-5 p-t p-b p-a-4-s p-a-4-m">
        <p class="s1 p1-s p-1-m m-b"
           *iCms="'pointsTitle' of content; skipEmpty true"></p>
        @if(points.length){
        <ul class="p-l-6 m-b m-b-3-s m-b-3-m"
            style="list-style: disc;">
            @for(point of points; track $index){
            <li class="p1 p2-s p-2-m">
                {{point.text}}
            </li>
            }
        </ul>
        }
        @if(content){
        <div class="b-a b-col-1 overflow-hidden s2 c1-s c1-m"
             style="border-radius: 12px;">
            <div class="p-t-2 p-b-2 center col-w bg-col-1"
                 *iCms="'tableTitle' of content">

            </div>
            <div class="w-12">
                <div class="w-12 bg-col-4 flex">
                    @for(heading of headings; track heading){

                    <div class="b-t b-col-1 p-a-2 p-r-1-s p-l-1-s flex flex-middle flex-justify-center center"
                         [class.b-r]="!$last"
                         [ngClass]="'_col-' + ($index + 1)">{{heading | translate}}
                    </div>
                    }
                </div>
                @for(row of content.rows; track $index){
                <div class="w-12 flex"
                     [ngClass]="$odd ? 'bg-col-5' : 'bg-col-51'">
                    @for(cell of cells; track $index){
                    <div class="b-t b-col-1 p-a-2 flex flex-middle flex-justify-center center"
                         [class.b-r]="!$last"
                         [ngClass]="'_col-' + ($index + 1)">
                        {{row[cell]}}
                    </div>
                    }
                </div>
                }
            </div>
        </div>
        }
    </div>
</div>